<template>
  <span v-if="!!conditionTextForSR" class="sr-only">
    {{ conditionTextForSR }}
  </span>
</template>

<script lang="ts" setup>
import {
  GOOD_CONDITION,
  PERFECT_CONDITION,
} from '~/models/ListingProduct.api.model';

interface Props {
  condition?: string;
}

const props = withDefaults(defineProps<Props>(), {
  condition: '',
});

const conditionTextForSR = computed(() => {
  switch (props.condition) {
    case GOOD_CONDITION:
      return 'Begagnad i bra skick,';
    case PERFECT_CONDITION:
      return 'Begagnad i perfekt skick,';
    default:
      return '';
  }
});
</script>

<style lang="scss" scoped></style>
